export default __webpack_public_path__ + "c435fd1936cf06de73c809a3e0bcdf8a.jpg";